<template>
  <div>
    <b-notification :has-icon="true" icon="database" :closable="false">
      <span v-html="$t('compCarbonFormsFoodsHelpData.text')" />
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'HelpData'
}
</script>
